import { render, staticRenderFns } from "./TreatmentDetailsTimelineSections.vue?vue&type=template&id=9fa9eb96&scoped=true"
import script from "./TreatmentDetailsTimelineSections.vue?vue&type=script&lang=js"
export * from "./TreatmentDetailsTimelineSections.vue?vue&type=script&lang=js"
import style0 from "./TreatmentDetailsTimelineSections.vue?vue&type=style&index=0&id=9fa9eb96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa9eb96",
  null
  
)

export default component.exports